import { render, staticRenderFns } from "./SectionAncestors.vue?vue&type=template&id=28ad440f&scoped=true&"
import script from "./SectionAncestors.vue?vue&type=script&lang=js&"
export * from "./SectionAncestors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad440f",
  null
  
)

export default component.exports